import Lang from "../../common/lang/Lang";
import { SystemNotificationModel } from "../../model";

export const urls = {
  home: "/settings",
  list: "/settings/notification-logs",
}

export const ListBreadcrumb = [
  {
    label: Lang.settings,
    url: urls.home
  },
  {
    label:"Notification Logs",
    url: "#"
  }
];


export interface IState {
  id: number;
  data?: SystemNotificationModel
}
